/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';
import AUNotificationComponent from '@aarhus-university/au-lib-react-components/src/components/AUNotificationComponent';
import AUButtonComponent from '@aarhus-university/au-lib-react-components/src/components/AUButtonComponent';
import { useUserContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { getNotificationType } from '../../lib/helpers';

type validTypes = 'warning' | 'attention' | 'confirm';

type Props = {
  systemMessage: ISystemMessage;
  previewMode?: boolean;
  onDismiss?: (message: ISystemMessage) => void;
};

const NotificationComponent: FC<Props> = ({
  systemMessage,
  previewMode = false,
  onDismiss = undefined,
}) => {
  const user = useUserContext();
  // eslint-disable-next-line max-len
  const renderActions: JSX.Element[] = (systemMessage.actions || []).filter((a) => !!a.text).map((action) => {
    if (action.uri) {
      return (
        <a
          className="button"
          href={action.uri}
          onClick={(event) => {
            if (previewMode) {
              event.preventDefault();
            }
          }}
        >
          {action.text}
        </a>
      );
    }
    if (!user?.auId) {
      return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>{null}</>
      );
    }
    return (
      <AUButtonComponent
        label={action.text}
        disabled={previewMode}
        onClick={() => {
          if (typeof onDismiss === 'function') {
            onDismiss(systemMessage);
          }
        }}
      />
    );
  });
  return (
    <AUNotificationComponent
      header={systemMessage.title}
      content={[<div dangerouslySetInnerHTML={{ __html: systemMessage.message }} />]}
      type={getNotificationType(systemMessage.severity) as validTypes}
      actions={renderActions}
    />
  );
};

NotificationComponent.displayName = 'NotificationComponent';
export default NotificationComponent;
